
import { Vue, Options } from "vue-class-component";
import Card from "@/app/ui/components/card/index.vue";
import Toggle from "@/app/ui/components/toggle-v2/index.vue";
import { MessagingServiceConfigurationController } from "@/app/ui/controllers/MessagingServiceConfigurationController";

@Options({
  components: {
    Card,
    Toggle
  }
})
export default class MessagingServiceConfigurationFormExpiryStatusSection extends Vue {
  get form() {
    return MessagingServiceConfigurationController.messageServiceForm;
  }

  get toggleValue() {
    // Toggle is ON (red) when forceExpired = false (not expired)
    // Toggle is OFF (gray) when forceExpired = true (expired)
    return !this.form.forceExpired;
  }

  set toggleValue(value: boolean) {
    // When toggle is ON (true), forceExpired should be false
    // When toggle is OFF (false), forceExpired should be true
    this.form.forceExpired = !value;
  }
}
